import { createGlobalStyle } from 'styled-components';
import ikoiIcon from './images/poi/ikoi.png';
import nursingHomeIcon from './images/poi/nursingHome.png';
import areaConsultationSupportIcon from './images/poi/areaConsultationSupport.png';
import areaComprehensiveSupportIcon from './images/poi/areaComprehensiveSupport.png';
import childCultureIcon from './images/poi/childCulture.png';
import childCareSupportIcon from './images/poi/childCareSupport.png';
import childConsultationIcon from './images/poi/childConsultation.png';
import nurseryIcon from './images/poi/nursery.png';
import elementarySchoolIcon from './images/poi/elementarySchool.png';
import juniorHighSchoolIcon from './images/poi/juniorHighSchool.png';

export const MarkerIconStyles = createGlobalStyle`
  .icon {
    background: none;
    width: 8px;
    height: 8px;
    background-size: contain;
    background-repeat: no-repeat;
    opacity: 1.0;
  }
  .iconWrapper {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
  }
  .text {
    color: #555;
    font-size: 10px;
    text-align: center;
    width: 100%;
    text-shadow: 0 0 1px #fff;
  }
  .marker {
    z-index: 20 !important;
    margin: -3px !important;
    width: 200px !important;
    margin-left: -100px !important;
    @media print {
      filter: brightness(20%);
    }
  }
  .poiIcon{
    @media print {
      filter: brightness(20%);
    }
  }
  .ikoi {
    background-image: url(${ikoiIcon});
  }
  .nursingHome {
    background-image: url(${nursingHomeIcon});
  }
  .areaConsultationSupport {
    background-image: url(${areaConsultationSupportIcon});
  }
  .areaComprehensiveSupport {
    background-image: url(${areaComprehensiveSupportIcon});
  }
  .childCulture {
    background-image: url(${childCultureIcon});
  }
  .childCareSupport {
    background-image: url(${childCareSupportIcon});
  }
  .childConsultation {
    background-image: url(${childConsultationIcon});
  }
  .nursery {
    background-image: url(${nurseryIcon});
    
  }
  .elementarySchool {
    background-image: url(${elementarySchoolIcon});
  }
  .juniorHighSchool {
    background-image: url(${juniorHighSchoolIcon});
  }
`;

export const GlobalStyles = createGlobalStyle`
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }

  body, html {
    width: 100%;
    height: 100%;
    overflow: hidden; /* for IE11 */
  }

  body {
    line-height: 1;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
      "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-print-color-adjust: exact !important;
    printer-colors: exact;
    color-adjust: exact;
  }

  ol,
  ul {
    list-style: none;
  }

  blockquote,
  q {
    quotes: none;
  }

  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
  }

  .recharts-wrapper, .recharts-wrapper > .recharts-surface {
    @media print {
      width: 100% !important;
      height: 100% !important;
    }
  }
`;
